var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26296_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45258 11.6252C7.38562 11.3656 7.25034 11.1288 7.0608 10.9392C6.87125 10.7497 6.63439 10.6144 6.37483 10.5474L1.77358 9.36094C1.69508 9.33866 1.62599 9.29138 1.57679 9.22627C1.52759 9.16117 1.50098 9.08179 1.50098 9.00019C1.50098 8.91858 1.52759 8.83921 1.57679 8.7741C1.62599 8.709 1.69508 8.66172 1.77358 8.63944L6.37483 7.45219C6.63429 7.38529 6.8711 7.25012 7.06063 7.06072C7.25017 6.87132 7.38551 6.6346 7.45258 6.37519L8.63908 1.77394C8.66114 1.69513 8.70837 1.62569 8.77357 1.57623C8.83878 1.52677 8.91837 1.5 9.00021 1.5C9.08205 1.5 9.16164 1.52677 9.22684 1.57623C9.29204 1.62569 9.33928 1.69513 9.36133 1.77394L10.5471 6.37519C10.614 6.63474 10.7493 6.87161 10.9389 7.06115C11.1284 7.25069 11.3653 7.38598 11.6248 7.45294L16.2261 8.63869C16.3052 8.66051 16.375 8.70769 16.4247 8.77299C16.4744 8.83829 16.5014 8.91811 16.5014 9.00019C16.5014 9.08227 16.4744 9.16208 16.4247 9.22738C16.375 9.29268 16.3052 9.33986 16.2261 9.36169L11.6248 10.5474C11.3653 10.6144 11.1284 10.7497 10.9389 10.9392C10.7493 11.1288 10.614 11.3656 10.5471 11.6252L9.36058 16.2264C9.33853 16.3052 9.29129 16.3747 9.22609 16.4241C9.16089 16.4736 9.0813 16.5004 8.99946 16.5004C8.91762 16.5004 8.83803 16.4736 8.77282 16.4241C8.70762 16.3747 8.66039 16.3052 8.63833 16.2264L7.45258 11.6252Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.25V5.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.75H13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75V14.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5H2.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26296_3220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMenu);
export default __webpack_public_path__ + "static/media/ai-menu.6088693dbf5df57bdce68d56662118e1.svg";
export { ForwardRef as ReactComponent };